module.exports = __webpack_public_path__ + "static/media/h1.89ecfdf0.jpg";